import { ButtonBase, Stack, Typography, useTheme } from "@mui/material";
import { CheckCheck } from "lucide-react";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import type { MarkAllReadButtonProps } from "web_myplann/NotificationCenter/Types/MarkAllReadButtonProps";

export const MarkAllReadLegacyButton: FC<MarkAllReadButtonProps> = ({
	onClick,
	disabled = false,
}) => {
	const { t } = useResource();
	const { palette, iconSize } = useTheme();

	return (
		<Stack alignItems="flex-end" px={1.6}>
			<ButtonBase
				sx={{ gap: 0.8, pb: 1.6 }}
				onClick={onClick}
				disabled={disabled}
				data-testid="notification-center-mark-all-read"
			>
				<CheckCheck size={iconSize.sm} color={palette.blue.main} />
				<Typography variant="body2" color={palette.blue.main}>
					{t(Resources.Notifications.readAll)}
				</Typography>
			</ButtonBase>
		</Stack>
	);
};
